import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore'
import {getAuth} from 'firebase/auth'
import {ApiKey} from "./apiKey";

  const app = initializeApp(ApiKey);
  export const db = getFirestore(app);
  export const auth = getAuth(app);
